<template>
    <div class=" flex items-center justify-center">
      <div class="container max-w-screen-lg mx-auto">
        <div>

          <div class="bg-white rounded shadow-lg p-4 px-4 md:p-8">
            <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">

              <div class="text-left mb-2">
                <p class="mb-2 font-medium text-lg text-gray-800">
                  {{ descriptionTitle }}
                </p>
                <p class="text-gray-500">
                  {{ descriptionSubTitle }}
                </p>
              </div>

              <div class="lg:col-span-2">
                <div
                  class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
                >
                  <!-- eventos -->
                  <div
                    class="md:col-span-5"
                  >
                    <label class="flex pl-1 text-xs text-[#2b3038]">
                      Eventos
                    </label>
                    <div class="h-10 flex rounded items-center mt-1">
                      <SimpleSelect
                        class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparen"
                        :initialValue="comboEvents[0]"
                        :data="comboEvents"
                        @selected-data="(val) => mountItemsToSend(val.value)"
                      />
                    </div>
                  </div>

                  <!-- coleção de itens -->
                  <div
                    v-if="collectionByFilter?.length"
                    class="mb-2 w-full p-1 md:col-span-5"
                    :key="collectionByFilter"
                  >
                    <div class="w-full flex justify-between text-gray-400 pt-2">
                      <small class="w-full mt-auto mb-auto text-left font-medium">
                        MEUS EVENTOS:
                      </small>
                    </div>

                    <div
                      class="inline-flex flex-wrap"
                      v-for="(item, index) in collectionByFilter"
                      :key="collectionByFilter"
                    >
                      <ArrayItemsVue
                        :item="item"
                        @removeItem="removeItemByDataItems(index)"
                        @updateItem="updateItemInList"
                      />
                    </div>
                  </div>

                  <div
                    v-else
                    class="md:col-span-5 w-full p-1"
                  >

                    <div class="w-full flex justify-between text-gray-400 pt-2">
                      <small class="w-full mt-auto mb-auto text-left font-medium">
                        AINDA NÃO HÁ EVENTO
                      </small>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div class="p-2 mt-1 mb-1" />

          <div>
            <slot />
          </div>

        </div>
      </div>
    </div>
  </template>

<script setup>
import BaseInput from '@/components/Inputs/BaseInput.vue'
import CleanInputButton from '../components/CleanInputButton.vue'
import ArrayItemsVue from '../components/ArrayItems.vue'
import { dataFighters } from '../store'
import SimpleSelect from '@/components/Select/SimpleSelect.vue'
import { computed, onMounted, ref } from 'vue'

import moment from 'moment'

defineProps({
  descriptionTitle: String,
  descriptionSubTitle: String
})

const store = dataFighters.state
// const comboEvents = computed(() => dataFighters.getters.getEvents)
const collectionByFilter = computed(() => dataFighters.getters.getCollectionByFilter)
const coupons = computed(() => dataFighters.getters.getMyEvents) // eventos que participa
const comboEvents = ref([
  {
    name: 'PRÓXIMOS EVENTOS',
    value: 'nexts'
  },
  {
    name: 'TODOS',
    value: 'all'
  }
])

function mountItemsToSend (item) {
  const filteredEvents = coupons.value
    ?.map(c => ({
      title: c.event?.title,
      coupon_id: c.event?.id,
      starts_at: c.event?.starts_at
    }))
    ?.filter(event => {
      if (item === 'nexts') {
        return moment(event?.starts_at).isSameOrAfter(moment(), 'day')
      }
      return true
    })

  dataFighters.commit('SET_MY_EVENTS', filteredEvents)
}

function removeItemByDataItems (index) {
  dataFighters.dispatch('removeItemByCollectValue', index)
}

function updateItemInList (updatedItem) {
  const itemIndex = dataFighters.getters.getMyEvents.findIndex((item) => item.id === updatedItem.id)
  if (itemIndex !== -1) {
    dataFighters.getters.getMyEvents[itemIndex] = updatedItem
    store.myEvents = dataFighters.getters.getMyEvents
  }
}

</script>
